import { cn } from "@heroui/theme";

export function AnalyticCard({
	label,
	value,
	noBorder = false,
	compact = false,
}: { label: string; value?: string; noBorder?: boolean; compact?: boolean }) {
	return (
		<div
			className={cn(
				"rounded-lg flex flex-col bg-background h-auto justify-between",
				!noBorder && "border-gray-300 border-1 transition-all hover:shadow-sm",
				compact ? "gap-2" : "gap-4 p-6 py-12",
			)}
		>
			<p className={cn("text-foreground-400", compact ? "text-sm" : "text-lg")}>
				{label}
			</p>
			<p className={cn("font-bold", compact ? "text-xl" : "text-3xl")}>
				{value || ""}
			</p>
		</div>
	);
}
